import { BaseScenariosService } from './base-scenarios-service';
import { SavedRetirementScenario, UserProfile } from '../types/retirementComparison';

class RetirementScenariosService extends BaseScenariosService<SavedRetirementScenario> {
  protected readonly STORAGE_KEY = 'larryshelp_retirement_scenarios';
  protected readonly SCENARIO_TYPE = 'retirement' as const;

  /**
   * Save a new retirement scenario
   */
  async saveRetirementScenario(scenario: Omit<SavedRetirementScenario, 'id' | 'createdAt'>): Promise<string> {
    return this.saveScenario(scenario);
  }

  /**
   * Get all retirement scenarios
   */
  async getAllRetirementScenarios(): Promise<Record<string, SavedRetirementScenario>> {
    return this.getAllScenarios();
  }

  /**
   * Get a specific retirement scenario by ID
   */
  async getRetirementScenario(id: string): Promise<SavedRetirementScenario | null> {
    return this.getScenario(id);
  }

  /**
   * Update an existing retirement scenario
   */
  async updateRetirementScenario(id: string, updates: Partial<SavedRetirementScenario>): Promise<boolean> {
    return this.updateScenario(id, updates);
  }

  /**
   * Delete a retirement scenario
   */
  async deleteRetirementScenario(id: string): Promise<boolean> {
    return this.deleteScenario(id);
  }

  /**
   * Get retirement scenarios as an array (for easier iteration)
   */
  async getRetirementScenariosArray(): Promise<SavedRetirementScenario[]> {
    return this.getScenariosArray();
  }

  /**
   * Clear all retirement scenarios
   */
  async clearAllRetirementScenarios(): Promise<void> {
    return this.clearAllScenarios();
  }
}

export const retirementScenariosService = new RetirementScenariosService();
export default retirementScenariosService;